<template>
    <main-layout>
        <div class="container">
            <H1 class="pageTitle" >EMAIL VERIFIED</H1>
          
            <div class="top40 is-size-5 has-text-white">
                Thank you! Your email has been verified. Please login:
                <br><br>
                <button class="button is-warning" @click="doLogin">LOG IN</button>
            </div>
        </div>
    </main-layout>
</template>

<script>
import MainLayout from '../layouts/Main.vue'

export default {
  components: {
    MainLayout
  },
  mounted: function () {
    // TODO: read from ?cookie? to see if there was a checkout pending before registration and
    // verification happened, and if so nav to checkout.
    // Also consider storing cart on server session?
    // Or maybe setting timestamp on cart and if older than x minutes clearing it?

    // alert(document.cookie)
  },
  methods: {
    doLogin: function () {
      this.$root.showModalLogin()
      this.$router.push('/')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Verified.vue